import { render } from "./AmenitiesList.vue?vue&type=template&id=4c59af90"
import script from "./AmenitiesList.vue?vue&type=script&lang=js"
export * from "./AmenitiesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__